import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.4
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function HeroSection() {
  return <section className="relative h-screen w-full overflow-hidden bg-sure-black" data-id="element-82">
      {/* Background Video */}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" src="https://media.istockphoto.com/id/2232124628/video/time-lapse-of-crowd-commuter-business-office-people-walking-and-crossing-road-in-rush-hour.mp4?s=mp4-640x640-is&k=20&c=QtdJXq7TiQLdVA7KueGUHT3tyRNELA4b1XTCHUIE8Qg=" data-id="element-83" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/65" data-id="element-84" />

      {/* Hero Content */}
      <div className="relative z-10 h-full w-full max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col justify-center pt-[15vh]" data-id="element-85">
        <motion.div className="max-w-3xl" variants={containerVariants} initial="hidden" animate="show" data-id="element-86">
          {/* Eyebrow */}
          <motion.div variants={itemVariants} className="mb-6" data-id="element-87">
            <span className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium" data-id="element-88">
              Passenger Intelligence for Public Transport
            </span>
          </motion.div>

          {/* Headline */}
          <motion.h1 variants={itemVariants} className="text-sure-white text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-8" data-id="element-89">
            Turn onboard data into decision-grade intelligence
          </motion.h1>

          {/* Subheadline */}
          <motion.p variants={itemVariants} className="text-sure-gray text-base md:text-lg font-light leading-relaxed max-w-2xl mb-12" data-id="element-90">
            SURE AI converts onboard video and vehicle signals into structured,
            anonymised intelligence that enables operators and authorities to
            make measurable, defensible decisions about safety, service and
            capacity. We activate infrastructure already in place, with no new
            cameras and no identity tracking.
          </motion.p>

          {/* CTAs */}
          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-start gap-6" data-id="element-91">
            <Link to="/contact" className="px-8 py-4 bg-sure-white text-sure-black text-sm uppercase tracking-widest font-medium hover:scale-[1.02] hover:bg-gray-100 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black inline-block text-center" data-id="element-92">
              Request a Briefing
            </Link>
            <Link to="/contact" className="px-8 py-4 border border-sure-white text-sure-white text-sm uppercase tracking-widest font-medium hover:bg-sure-white hover:text-sure-black transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sure-accent focus:ring-offset-2 focus:ring-offset-sure-black inline-block text-center" data-id="element-93">
              Arrange a Demonstration
            </Link>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-94">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-sure-white/50" data-id="element-95">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-96">
            <polyline points="6 9 12 15 18 9" data-id="element-97"></polyline>
          </svg>
        </motion.div>
      </motion.div>
    </section>;
}